// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BadgeList_root__ye4w0>span{margin-right:4px;margin-bottom:4px}", "",{"version":3,"sources":["webpack://./src/common/Badge/BadgeList.scss"],"names":[],"mappings":"AAGE,4BACE,gBAAA,CACA,iBAAA","sourcesContent":["@import \"assets/styles/variables.scss\";@import 'assets/styles/variables';\n\n.root {\n  > span {\n    margin-right: 4px;\n    margin-bottom: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "BadgeList_root__ye4w0"
};
export default ___CSS_LOADER_EXPORT___;
